import type { ScenarioType } from "@reco/shared/src/constants";
import type { GridBox } from "@reco/shared/src/types/gridbox";

export function getTrackingValue(scenario: ScenarioType): string {
  return `reco_rdp_${scenario}`;
}

export function prepareGridData(product: GridBox) {
  const trackingProduct = {
    ...product,
    listId: product.list,
    listName: product.list,
  };

  return JSON.stringify(trackingProduct);
}
